/**
 * Detect WebGL support. Result is cached after first call.
 */
let _supported = null;

export function isWebGLSupported() {
  if (_supported !== null) return _supported;

  try {
    const canvas = document.createElement('canvas');
    _supported = !!(
      canvas.getContext('webgl') ||
      canvas.getContext('experimental-webgl')
    );
  } catch {
    _supported = false;
  }

  return _supported;
}
